/**
 * Sizes available on images, where S1 is the smallest and S5 the largest.
 */
enum ImageSizeTypeEnum {
	S1 = 'S1',
	S2 = 'S2',
	S3 = 'S3',
	S4 = 'S4',
	S5 = 'S5'
}

export default ImageSizeTypeEnum;
